import { lazy, Suspense, type FC } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';

import { type PdpSharedSendToFriendModalLazy_viewer$data } from './__generated__/PdpSharedSendToFriendModalLazy_viewer.graphql';
import { type PdpSharedSendToFriendModalLazy_user$data } from './__generated__/PdpSharedSendToFriendModalLazy_user.graphql';
import { type PdpSharedSendToFriendModalLazy_item$data } from './__generated__/PdpSharedSendToFriendModalLazy_item.graphql';

const PdpSharedSendToFriendModal = lazy(
    () => import(/* webpackChunkName: "AuthShareModal" */ './AuthShareModal')
);

type Props = {
    closeModal: () => void;
    setIsLoading: (isLoading: boolean) => void;
    isLoading: boolean;
    hasError?: boolean;
    hasSuccess?: boolean;
    setError: () => void;
    setSuccess: () => void;
    modalOpen: boolean;
    onUserLogin?: (senderEmail: string, isRecentlySignedUpUser: boolean) => void;
    isRecentlySignedUpUser: boolean;
    senderEmail?: string;
    skuId?: string;
    imageSrc: string;
    type: string;
    isSubmitInitiallyEnabled?: boolean;
    user: PdpSharedSendToFriendModalLazy_user$data | null | undefined;
    item: PdpSharedSendToFriendModalLazy_item$data | null | undefined;
    viewer: PdpSharedSendToFriendModalLazy_viewer$data | null | undefined;
};

const PdpSharedSendToFriendModalLazyComponent: FC<Props> = props => {
    return props.modalOpen ? (
        <Suspense fallback={''}>
            <PdpSharedSendToFriendModal {...props} />
        </Suspense>
    ) : null;
};

export const PdpSharedSendToFriendModalLazy = createFragmentContainer(
    PdpSharedSendToFriendModalLazyComponent,
    {
        viewer: graphql`
            fragment PdpSharedSendToFriendModalLazy_viewer on Viewer {
                ...AuthShareModal_viewer @include(if: $afterDisplay)
            }
        `,
        user: graphql`
            fragment PdpSharedSendToFriendModalLazy_user on User {
                ...AuthShareModal_user
            }
        `,
        item: graphql`
            fragment PdpSharedSendToFriendModalLazy_item on Item {
                ...AuthShareModal_item
            }
        `,
    }
);
